import type { UseCase } from '@/core/shared'
import type { StripeRepository } from '@/core/stripe'

export const createPaymentsAccount: UseCase<StripeRepository, 'createPaymentsAccount'> = repository => {
  return async (groupUid) => {
    await repository.createPaymentsAccount(groupUid)
  }
}
